import { render, staticRenderFns } from "./smallTicket.vue?vue&type=template&id=43e0e316&scoped=true&"
import script from "./smallTicket.vue?vue&type=script&lang=js&"
export * from "./smallTicket.vue?vue&type=script&lang=js&"
import style0 from "./smallTicket.vue?vue&type=style&index=0&id=43e0e316&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e0e316",
  null
  
)

export default component.exports